var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ckeditor", {
    attrs: { config: _vm.editorConfig, editor: _vm.editor },
    model: {
      value: _vm.text,
      callback: function ($$v) {
        _vm.text = $$v
      },
      expression: "text",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }